























































































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconShoppingCart',
  props: {
    width: {
      type: String,
      default: '21',
    },
    height: {
      type: String,
      default: '20',
    },
  },
});
